import { useState } from 'react';
import { cn } from "@/utils/cn";

interface AlertBannerProps {
  className?: string;
}

export function AlertBanner({ className }: AlertBannerProps) {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={cn("bg-red-600 text-white", className)}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-2">
          <div className="flex items-center justify-center w-full">
            <p className="text-sm font-medium text-center">
              Fabric Hangar For Sale
            </p>
          </div>
          <div className="flex-shrink-0">
            <button
              type="button"
              onClick={() => setIsVisible(false)}
              className="inline-flex rounded-md p-1 text-red-200 hover:text-white hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-red-600 transition-colors duration-150"
              aria-label="Dismiss alert"
            >
              <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}